<template>
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" fill="currentColor" style="enable-background:new 0 0 100 100" viewBox="0 0 100 100" class="select-none w-full"><title>Mapa prodavnica</title><path d="M50 8.4C33.3 8.4 19.8 22 19.8 38.7 19.8 65.4 50 91.6 50 91.6s30.2-26.1 30.2-52.9C80.2 22 66.7 8.4 50 8.4zM50 50c-6.3 0-11.3-5-11.3-11.3s5-11.3 11.3-11.3 11.3 5 11.3 11.3S56.3 50 50 50z"/></svg>
  </span>
</template>

<script>
  export default {
    name: "LocationIcon",
    props: {
      svgClassName: {
        type: String,
        default: ""
      }
    }
  }
</script>